module.exports = __webpack_public_path__ + "r-v3/img/stopwatch_pause_click.6524c4a9.svg";